import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const findOtherUsersWithSameCreditCards = async (callerId: string) => {
  const response = await queryExecute({
    variables: {
      callerId,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query FindOtherUsersWithSameCreditCards($callerId: String!) {
        findOtherUsersWithSameCreditCards(callerId: $callerId) {
          id
          firstName
          lastName
          email
          phoneNumber
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          registeredByUser
          createdAt
          cardInfo {
            id
            object
            address_city
            address_country
            address_line1
            address_line1_check
            address_line2
            address_state
            address_zip
            address_zip_check
            brand
            country
            customer
            exp_month
            exp_year
            fingerprint
            funding
            last4
            name
            is_default
            metadata
            email
            phone
            notes
            cvc_check
            distanceFromHomeAddressInMiles
          }
        }
      }
    `),
  });

  return response.data.findOtherUsersWithSameCreditCards ?? [];
};
